import { render, staticRenderFns } from "./KompetenzrasterBewertungModal.vue?vue&type=template&id=3077d097"
import script from "./KompetenzrasterBewertungModal.vue?vue&type=script&lang=js"
export * from "./KompetenzrasterBewertungModal.vue?vue&type=script&lang=js"
import style0 from "./KompetenzrasterBewertungModal.vue?vue&type=style&index=0&id=3077d097&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports